import _                                  from 'underscore';
import React, { FC, useEffect, useState } from 'react';
import { useQuery }                       from '@apollo/react-hooks';

import { CorvalCategory, Uuid }                 from '@src/types';
import { queriesHaveData, queriesLoading }      from '@src/store/_apolloUtil';
import { DecisionEngineQueries }                from '@src/queries';
import { formatOption, IFormatOptionValue }     from '@src/util';
import { QueriedSelectFieldProps, SelectField } from '@src/views/components/forms';


interface CategoryDropdownProps extends QueriedSelectFieldProps {
    loading?: boolean,
    formatOptions?: object,
    contextOwnerProjectId?: Uuid
}

const defaultProps: CategoryDropdownProps = {
    loading:               false,
    formatOptions:         {},
    contextOwnerProjectId: null,
};

const CategoryDropdown: FC<CategoryDropdownProps> = ( _props ) => {

    let { formatOptions, contextOwnerProjectId, ...props } = _props;

    const [ categories, setCategories ] = useState<IFormatOptionValue[]>( [] );

    let getCategoriesReq = useQuery(
        DecisionEngineQueries.queries.GET_CATEGORIES( `id name ordinal contextOwnerProjectId` ), {
            variables:   { order: { ordinal: 'ASC' } },
            fetchPolicy: 'cache-and-network'
        } );

    let isLoading = ( props.loading || queriesLoading( getCategoriesReq ) );

    useEffect( () => {

        if( queriesHaveData( getCategoriesReq ) ){

            let availableCategories = getCategoriesReq.data.categories,
                categoryOptions     = [];

            // reduce to only owned categories
            if( !_.isNull( contextOwnerProjectId ) ){
                availableCategories = _.filter( availableCategories, ( cat ) => {
                    return [ null, contextOwnerProjectId ].includes( cat.contextOwnerProjectId )
                } )
            }

            // convert top options
            categoryOptions = availableCategories.map( ( category: CorvalCategory ) => formatOption( category.id, category.name, formatOptions ) )

            setCategories( categoryOptions );
        }

    }, [ getCategoriesReq ] );

    return (
        <SelectField
            { ...props }
            search
            loading={ isLoading }
            options={ categories }
        />
    );
};

CategoryDropdown.defaultProps = defaultProps;

export { CategoryDropdown };
